/**
 * Bilan de fin de parcours DAG : score total, XP gagnée, bonnes réponses et
 * usage du chemin développé. Pas de nom technique de misconception.
 */
import { Button } from '@jeraisonne/ui';
import { Trophy, Sparkles } from 'lucide-react';
import type { AnswerLogEntry } from './use-dag-player';

export function ResultSummary({
  score,
  xpGain,
  answers,
  onReplay,
  onExit,
}: {
  score: number;
  xpGain: number | null;
  answers: AnswerLogEntry[];
  onReplay: () => void;
  onExit: () => void;
}) {
  const correct = answers.filter((a) => a.correct).length;
  const developedUsed = answers.some((a) => a.isSub);

  return (
    <div className="space-y-4 text-center">
      <div className="bg-xp-50 mx-auto flex h-16 w-16 items-center justify-center rounded-2xl">
        <Trophy className="text-xp-600 h-8 w-8" />
      </div>
      <div>
        <h2 className="font-display text-ink-900 text-xl font-extrabold">Parcours terminé !</h2>
        <p className="text-ink-500 mt-1 text-sm">Tu as déroulé tout le raisonnement.</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="border-ink-200 rounded-2xl border bg-white p-4">
          <p className="text-ink-900 text-2xl font-extrabold">{score}</p>
          <p className="text-ink-500 text-xs">points</p>
        </div>
        <div className="border-xp-200 bg-xp-50 rounded-2xl border p-4">
          <p className="text-xp-700 flex items-center justify-center gap-1 text-2xl font-extrabold">
            <Sparkles className="h-5 w-5" />+{xpGain ?? 0}
          </p>
          <p className="text-xp-600 text-xs">XP</p>
        </div>
      </div>

      <p className="text-ink-600 text-sm">
        {correct} bonne{correct > 1 ? 's' : ''} réponse{correct > 1 ? 's' : ''}
        {developedUsed ? ' · chemin développé utilisé' : ''}
      </p>

      <div className="flex flex-col gap-2 pt-2 sm:flex-row-reverse">
        <Button fullWidth onClick={onReplay}>
          Recommencer
        </Button>
        <Button variant="secondary" fullWidth onClick={onExit}>
          Retour
        </Button>
      </div>
    </div>
  );
}
